import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { Link } from 'react-router-dom'
import { fetch, remove } from 'actions/reservation'
import { updateSelectLanguagesAction, updateEventLanguageAction } from 'actions/languages'
import CartSummary from 'components/CartSummary'
import WineAroundDownload from 'components/WineAroundDownload'
import EventPaymentInstructions from 'components/EventPaymentInstructions'

import queryString from 'querystring'

export class Reservation extends React.Component {
  componentDidMount() {
    const { fetchReservation, match, updateSelectLanguages, updateEventLanguage } = this.props
    const { reservationId } = match.params
    const { phone, email } = queryString.parse(location.search.replace('?', ''))

    fetchReservation(reservationId, phone, email)
      .then(({ payload }) => {
        updateSelectLanguages(payload.response.event.languages)
        updateEventLanguage(payload.response.language)
      })
  }

  removeReservationClicked(e) {
    e.preventDefault()
    const { reservation, removeReservation, intl } = this.props
    const { formatMessage } = intl
    const { id, phone, email } = reservation.data

    if (window.confirm(formatMessage({ // eslint-disable-line no-alert
      id: 'app.reservation.view.remove-button.confirm',
    }))) {
      removeReservation(id, phone, email)
    }
  }

  render() {
    const { reservation, locale } = this.props

    const event = reservation.data.event
    if (!event) {
      return null
    }

    const cellarId = reservation.data.cellar
      ? reservation.data.cellar._id
      : event.cellar._id
    const eventLanguage = reservation.data.language

    const removeButton = ['pending', 'confirmed'].indexOf(reservation.data.status) > -1
      && new Date(event.start) > new Date()
      &&
      (
        <div
          className="grid__item lap-6-12 space--both-2"
          style={{ textAlign: 'center' }}
        >
          <a
            className="button button--secondary button--small"
            style={{ textAlign: 'center', whiteSpace: 'normal' }}
            onClick={ this.removeReservationClicked.bind(this) }
          >
            <FormattedMessage
              id="app.reservation.view.remove-button.text"
            />
          </a>
        </div>
      )

    return (
      <div className="reservation">
        <div className="reservation__progress">
          <div className="wrap">
            <Link
              to={`/${locale}/${cellarId}?lang=${eventLanguage}`}
              className="button button--secondary button--large"
            >
              <FormattedMessage
                id="app.reservation.view.header.back-to-cellar"
              />
            </Link>
          </div>
        </div>
        <hr id="reservation-view__hr" />
        <div className="reservation__body">
          <div className="wrap">
            <div className="reservation-box">
              <div className="reservation-box__title">
                <FormattedMessage
                  id="app.reservation.view.title"
                />
              </div>
              <div className="wrap">
                <CartSummary
                  cart={reservation}
                  event={event}
                />
                <div className="grid">
                  <div className="grid__item lap-6-12">
                    <div className="space--both-2">
                      <h2 className="beta">
                        <FormattedMessage id="app.cart.step.end.info.title" />
                      </h2>
                      {
                        !event.hidePrice &&
                        <EventPaymentInstructions
                          paymentDisabled={!reservation.data.last4}
                          payment={event.payment}
                          currency={event.location.currency}
                          price={event.price.value}
                          priceMode={event.price.mode}
                          guests={reservation.data.guests}
                          coupon={reservation.coupon}
                          eventExtras={event.extras}
                          reservationExtras={reservation.data.extras}
                          customPaymentText={event.payment_text}
                          customProductText={event.default_product_plural}
                        />
                      }
                    </div>
                  </div>
                  <div className="grid__item lap-6-12">
                    <WineAroundDownload
                      revert="true"
                    />
                  </div>
                  { removeButton }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Reservation.propTypes = {
  reservation: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  fetchReservation: PropTypes.func.isRequired,
  removeReservation: PropTypes.func.isRequired,
  updateSelectLanguages: PropTypes.func.isRequired,
  updateEventLanguage: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    reservation: state.reservation,
    locale: state.ui.locale,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchReservation: fetch,
    removeReservation: remove,
    updateSelectLanguages: updateSelectLanguagesAction,
    updateEventLanguage: updateEventLanguageAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Reservation))
